/* US v67 (30 oct) : Le Triptyque rétabli (variante PRE_VID à renseigner, $49) — traité comme un cabinet : jalons et livraison selon le seuil $119, pas de relance « 2nd / 3rd cabinet » quand il est au panier (prix des packs faux), ligne « All 3 fragrances · 30 loads ». */
/* US v63 (21 oct) : noms 1/2/3 cabinets, −10 % / −20 %, essence ajoutée ≠ essences du panier, bouton « Upgrade to 2/3 cabinets », 4e « at the Maison’s price », bouton Checkout — prix (le code était inatteignable). */
/* US v62 (15 oct) : port FR v25 — L’Essentiel aims at Le Favori ($89), Le Favori at Le Rituel ($119), « Checkout — price » button, real payment logos. */
/* Tiroir panier v2 — milestones, upsell upgrade/4e boîte, gift $119. US v61 : prix $49/$89/$119, livraison offerte + L'Embaumeur uniquement avec Le Rituel ($119). */
(function () {
  var dataEl = document.querySelector("[data-c2-data]");
  if (!dataEl) return;
  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var miles = document.querySelector("[data-c2-miles]");
  var SHIP = miles ? parseInt(miles.getAttribute("data-ship"), 10) : 11900;
  var GIFT = miles ? parseInt(miles.getAttribute("data-gift"), 10) : 11900;
  var GIFT_VARIANT = miles ? parseInt(miles.getAttribute("data-gift-variant"), 10) : 0;
  var FAV = miles ? parseInt(miles.getAttribute("data-fav") || "8900", 10) : 8900;
  var DUO_ICON = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="9" height="12" rx="1.5"/><rect x="13" y="5" width="9" height="12" rx="1.5"/></svg>';
  var FOUR_VIDS = Object.values(CFG.vids.four || {});
  var giftSyncing = false, giftFailed = false, busy = false;
  var chosen = { upgrade: null, four: null };

  function money(cents) { return "$" + (cents % 100 === 0 ? (cents / 100) : (cents / 100).toFixed(2)); }
  var PRE_VID = 67380637073649;
  function isPre(it) { return it.variant_id === PRE_VID; }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;"); }

  async function getCart() { return (await fetch("/cart.js")).json(); }

  async function syncGift(cart) {
    if (!GIFT_VARIANT || giftSyncing) return cart;
    var paid = cart.items.filter(function (i) { return i.variant_id !== GIFT_VARIANT; });
    var gift = cart.items.find(function (i) { return i.variant_id === GIFT_VARIANT; });
    var paidTotal = paid.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var unlocked = paidTotal >= GIFT;
    try {
      if (unlocked && !gift && paid.length && !giftFailed) {
        giftSyncing = true;
        var r = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: GIFT_VARIANT, quantity: 1 }) });
        if (!r.ok) giftFailed = true; else return await getCart();
      } else if ((!unlocked || !paid.length) && gift) {
        giftSyncing = true;
        await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: gift.key, quantity: 0 }) });
        return await getCart();
      }
    } catch (e) {} finally { giftSyncing = false; }
    return cart;
  }

  function scentChips(group, sel, note) {
    return CFG.scents.map(function (s) {
      var extra = CFG.shipNote[s] && note ? '<i>' + esc(CFG.shipNote[s]) + "</i>" : "";
      return '<button type="button" class="c2-chip' + (s === sel ? " is-sel" : "") + '" data-c2-scent="' + esc(s) + '" data-c2-group="' + group + '">' + esc(CFG.scentShort[s] || s) + extra + "</button>";
    }).join("");
  }

  function renderUpsell(paid, extras) {
    var box = document.querySelector("[data-c2-upsell]");
    if (!box) return;
    box.innerHTML = "";
    if (paid.length !== 1 || paid[0].quantity !== 1) return;
    var line = paid[0];
    if (isPre(line)) return;
    var pack = CFG.packs[String(line.product_id)];
    if (!pack) return;

    if (pack.handle === "lessentiel" || pack.handle === "le-favori") {
      var toRituel = pack.handle === "le-favori";
      var delta = toRituel ? 3000 : 4000;
      var target = toRituel ? "3 cabinets" : "2 cabinets";
      var save = toRituel ? "−20%" : "−10%";
      var perk = toRituel ? "unlocks free shipping + L’Embaumeur (a $25 gift)" : "two essences · $1.48 per wash instead of $1.63";
      var head = toRituel ? "A 3RD CABINET — FREE SHIPPING AND L’EMBAUMEUR" : "A 2ND CABINET — BOTH FOR $89";
      if (!chosen.upgrade) { var curS = (line.variant_title || "").split(" / "); chosen.upgrade = CFG.scents.filter(function (x) { return curS.indexOf(x) === -1; })[0] || CFG.scents[0]; }
      box.innerHTML =
        '<div class="c2-up"><p class="c2-up__head">' + head + "</p>" +
        '<div class="c2-up__card">' +
        '<div class="c2-up__chips">' + scentChips("upgrade", chosen.upgrade, true) + "</div>" +
        '<div class="c2-up__row"><div>' +
        '<p class="c2-up__price"><s>' + money(line.final_line_price) + '</s> <b>+' + money(delta) + "</b> <span>" + save + "</span></p>" +
        '<p class="c2-up__perk">' + perk + "</p></div>" +
        '<button type="button" class="c2-up__btn" data-c2-upgrade data-line-key="' + line.key + '" data-target="' + (toRituel ? "le-rituel" : "le-favori") + '" data-current="' + esc(line.variant_title || "") + '">' + (toRituel ? "Upgrade to 3 cabinets" : "Upgrade to 2 cabinets") + '</button>' +
        "</div></div></div>";
    } else if (pack.handle === "le-rituel") {
      var four = CFG.vids.four || {};
      if (!Object.keys(four).length) return;
      if (extras && extras.length) return;
      if (!chosen.four) chosen.four = CFG.scents[0];
      box.innerHTML =
        '<div class="c2-up"><p class="c2-up__head">ONE MORE FOR THE GUEST ROOM — PRIVATE PRICE</p>' +
        '<div class="c2-up__card">' +
        '<div class="c2-up__chips">' + scentChips("four", chosen.four, true) + "</div>" +
        '<div class="c2-up__row"><div>' +
        '<p class="c2-up__price"><s>' + money(CFG.fourCompare) + "</s> <b>" + money(CFG.fourPrice) + '</b> <span>−' + Math.round(100 - CFG.fourPrice / CFG.fourCompare * 100) + '%</span></p>' +
        '<p class="c2-up__perk">a 4th cabinet, at the Maison’s price</p></div>' +
        '<button type="button" class="c2-up__btn" data-c2-four>Add</button>' +
        "</div></div></div>";
    }
  }

  function render(cart) {
    var paid = cart.items.filter(function (i) { return i.variant_id !== GIFT_VARIANT && FOUR_VIDS.indexOf(i.variant_id) === -1; });
    var extras = cart.items.filter(function (i) { return FOUR_VIDS.indexOf(i.variant_id) !== -1; });
    var gift = cart.items.find(function (i) { return i.variant_id === GIFT_VARIANT; });
    var all = paid.concat(extras);
    var count = all.reduce(function (s, i) { return s + i.quantity; }, 0);
    var total = all.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var hasPre = all.some(isPre); /* v45 : avec Le Triptyque, pas de message « 2nd / 3rd cabinet » → message livraison seul */

    document.querySelectorAll("[data-dv-cart-count]").forEach(function (el) {
      el.textContent = count; el.style.display = count > 0 ? "" : "none";
    });
    var hc = document.querySelector("[data-dv-cart-headcount]");
    if (hc) hc.textContent = count > 0 ? count + (count === 1 ? " item" : " items") : "";

    if (miles) {
      miles.style.display = all.length ? "" : "none";
      var fill = document.querySelector("[data-c2-miles-fill]");
      var msg = document.querySelector("[data-c2-miles-msg]");
      var nShip = document.querySelector("[data-c2-node-ship]");
      var nGift = document.querySelector("[data-c2-node-gift]");
      var unlockedU = total >= GIFT;
      var toFav = !unlockedU && !hasPre && total < FAV;
      var target = toFav ? FAV : GIFT;
      if (fill) fill.style.width = (unlockedU ? 100 : Math.min(total / target, 1) * 100) + "%";
      if (nShip) nShip.classList.toggle("is-on", total >= SHIP);
      if (nGift) { nGift.classList.toggle("is-on", unlockedU); if (!nGift._gift) nGift._gift = nGift.innerHTML; nGift.innerHTML = toFav ? DUO_ICON : nGift._gift; }
      if (msg) {
        if (unlockedU) msg.innerHTML = "Free shipping and <em>L'Embaumeur</em>: unlocked";
        else if (toFav) msg.innerHTML = "Only <strong>" + money(FAV - total) + "</strong> more: a 2nd cabinet, <span style=\"white-space:nowrap\">$1.48 per wash</span>";
        else if (hasPre) msg.innerHTML = "Only <strong>" + money(GIFT - total) + "</strong> more: free shipping <span style=\"white-space:nowrap\">+ <em>L’Embaumeur</em> ($25)</span>";
        else msg.innerHTML = "Only <strong>" + money(GIFT - total) + "</strong> more: a 3rd cabinet, free shipping <span style=\"white-space:nowrap\">+ <em>L’Embaumeur</em> ($25)</span>";
      }
    }
    var note = document.querySelector("[data-c2-ship-note]");
    if (note) note.textContent = total >= SHIP ? "Free shipping unlocked" : (hasPre ? "Free shipping from " + money(SHIP) : "Free shipping with Le Rituel");

    var body = document.querySelector("[data-c2-lines]");
    var foot = document.querySelector("[data-c2-foot]");
    if (!body) return;
    if (!all.length) {
      body.innerHTML = '<p class="dv-drawer__empty">' + body.getAttribute("data-empty") + "</p>";
      renderUpsell([], []);
      if (foot) foot.style.display = "none";
      return;
    }
    if (foot) foot.style.display = "";
    var sub = document.querySelector("[data-c2-subtotal]");
    if (sub) sub.textContent = money(total);

    var html = all.map(function (it) {
      var pack = CFG.packs[String(it.product_id)] || {};
      var title = pack.name || it.product_title;
      var vt = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
      var benefit = pack.benefit || (isPre(it) ? "All 3 fragrances · 30 loads" : "");
      var save = pack.save ? ' <span class="c2-line__save">' + pack.save + "</span>" : "";
      return '<div class="dv-line" data-line-key="' + it.key + '">' +
        '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2") : "") + '" alt="">' +
        '<div class="dv-line__body">' +
        '<p class="dv-line__title">' + esc(title) + save + "</p>" +
        (vt ? '<p class="dv-line__variant">' + esc(vt) + "</p>" : "") +
        (benefit ? '<p class="dv-line__variant" style="opacity:.75">' + esc(benefit) + "</p>" : "") +
        '<div class="dv-line__row">' +
        '<span class="dv-qty"><button data-c2-qty="-1" aria-label="−">−</button><span>' + it.quantity + '</span><button data-c2-qty="1" aria-label="+">+</button></span>' +
        '<span class="dv-line__price">' + money(it.final_line_price) + "</span></div>" +
        '<button class="dv-line__remove" data-c2-remove>' + body.getAttribute("data-remove") + "</button>" +
        "</div></div>";
    }).join("");

    if (gift) {
      html += '<div class="dv-line dv-line--gift"><span class="dv-line__giftbox">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></span>' +
        '<div class="dv-line__body"><div class="dv-line__row" style="margin-top:0">' +
        '<p class="dv-line__title">L’Embaumeur</p><span class="dv-line__gifttag">Gift · <s>$25</s></span></div>' +
        '<p class="dv-line__variant">Perfumed wardrobe sachet · included with your order</p></div></div>';
    }
    body.innerHTML = html;
    var go = document.querySelector("[data-c2-checkout]");
    if (go) go.textContent = (go.getAttribute("data-label") || "Checkout") + " — " + money(total);
    renderUpsell(paid, extras);
  }

  var pending = false;
  async function refresh() {
    if (pending) return; pending = true;
    try {
      var cart = await getCart();
      cart = await syncGift(cart);
      render(cart);
    } catch (e) {} finally { pending = false; }
  }

  /* resync : toute mutation du panier, d'où qu'elle vienne */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === "string" ? arguments[0] : (arguments[0] && arguments[0].url) || "";
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(refresh, 60); });
    }
    return p;
  };

  document.addEventListener("click", async function (ev) {
    if (ev.target.closest("[data-dv-cart-open]")) refresh();

    var chip = ev.target.closest("[data-c2-scent]");
    if (chip) {
      chosen[chip.getAttribute("data-c2-group")] = chip.getAttribute("data-c2-scent");
      chip.parentNode.querySelectorAll(".c2-chip").forEach(function (c) { c.classList.remove("is-sel"); });
      chip.classList.add("is-sel");
      return;
    }

    var up = ev.target.closest("[data-c2-upgrade]");
    if (up && !busy) {
      busy = true; up.textContent = "…";
      try {
        var target = up.getAttribute("data-target");
        var current = up.getAttribute("data-current");
        var title = current + " / " + chosen.upgrade;
        var vid = (CFG.vids[target] || {})[title];
        if (vid) {
          await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: up.getAttribute("data-line-key"), quantity: 0 }) });
          await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: vid, quantity: 1 }) });
          chosen.upgrade = null;
        }
      } catch (e) {} finally { busy = false; refresh(); }
      return;
    }

    var four = ev.target.closest("[data-c2-four]");
    if (four && !busy) {
      busy = true; four.textContent = "…";
      try {
        var fvid = (CFG.vids.four || {})[chosen.four];
        if (fvid) {
          await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: fvid, quantity: 1 }) });
          four.textContent = "Added ✓";
        }
      } catch (e) {} finally { busy = false; refresh(); }
      return;
    }

    var qtyBtn = ev.target.closest("[data-c2-qty]");
    var rmBtn = ev.target.closest("[data-c2-remove]");
    if (!qtyBtn && !rmBtn) return;
    var line = ev.target.closest("[data-line-key]");
    if (!line) return;
    var qty = 0;
    if (qtyBtn) {
      var cur = parseInt(line.querySelector(".dv-qty span").textContent, 10);
      qty = Math.max(0, cur + parseInt(qtyBtn.getAttribute("data-c2-qty"), 10));
    }
    await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: line.getAttribute("data-line-key"), quantity: qty }) });
    refresh();
  });

  refresh();
})();
